<template>
  <div v-if="!isMobile">
    <div
      id="landing_buy_blu"
      class="column landing_buy_blu p0 h100 card-boder-bg"
    >
      <div style="height: 100%">
        <div
          id="baseBuyStep_1"
          class="step_1 h100"
          v-if="transactionState === 0"
        >
          <base-buy-blu-buy
            @callNextState="callNextState"
            :fees="fees"
          ></base-buy-blu-buy>
        </div>

        <div
          id="baseBuyStep_2"
          class="step_2 h100"
          v-if="transactionState === 1"
        >
          <base-buy-blu-watch
            :paymentMode="paymentMode"
            :fees="fees"
            :bluTusd="bluTusd"
            :purchaseWaiting="purchaseWaiting"
            @callNextState="callNextState"
            @maintenanceCheck="maintenanceCheck"
            @backToStart="() => (transactionState = 0)"
          ></base-buy-blu-watch>
        </div>
      </div>
    </div>
  </div>

  <div class="tabs_mobile" v-else>
    <div class="tab">
      <input class="tab_input" checked type="checkbox" id="buy_blu" />
      <label class="tab-label" style="background: #342365; color: #fff;">{{ $t("msg.buy_token") }}</label>
      <div class="tab-content">
        <div id="landing_buy_blu" class="column landing_buy_blu p0 h100">
          <div style="height: 100%">
            <div
              id="baseBuyStep_1"
              class="step_1 h100"
              v-if="transactionState === 0"
            >
              <base-buy-blu-buy
                @callNextState="callNextState"
                :fees="fees"
              ></base-buy-blu-buy>
            </div>

            <div
              id="baseBuyStep_2"
              class="step_2 h100"
              v-if="transactionState === 1"
            >
              <base-buy-blu-watch
                :paymentMode="paymentMode"
                :fees="fees"
                :bluTusd="bluTusd"
                :purchaseWaiting="purchaseWaiting"
                @callNextState="callNextState"
                @maintenanceCheck="maintenanceCheck"
                @backToStart="() => (transactionState = 0)"
              ></base-buy-blu-watch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import baseBuyBluBuy from "./BaseBuyBluBuy";
import baseBuyBluWatch from "./BaseBuyBluWatch";
import { TheMask } from "vue-the-mask";
import LoadingBuyBlu from "../../../public/LoadingBuyBlu";

export default {
  created() {
    this.getFees();
    this.getPurchases();
    this.checkIfMobile();
  },
  mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    fees: "",
    selectedAccount: "",
    bluAmount: 0,
    btc: "",
    maxBluAmount: 99999999999,
    tooltipBonus: false,
    tooltipStratum: false,
    transactionState: 0,
    tooLong: false,
    btcAccount: "",
    paymentMode: "",
    bluTusd: "",
    purchases: "",
    purchaseWaiting: "",
    loading: true,
    isMobile: false,
    myBalanceExpand: true,
  }),
  components: {
    baseBuyBluBuy,
    baseBuyBluWatch,
    TheMask,
    LoadingBuyBlu,
  },
  methods: {
    async getPurchases() {
      try {
        let resp = await this.$store.dispatch("getPurchases");
        this.purchases = resp.data;
      } catch (e) {
        this.logError(e);
      }
    },

    toggleMenu() {
      this.myBalanceExpand = !this.myBalanceExpand;
    },

    async getFees() {
      try {
        let resp = await this.$store.dispatch("getFees");
        let purchaseFee = resp.data.filter((fee) => {
          if (fee.createdAt) {
            return fee.type == "purchase";
          }
        });

        purchaseFee.sort((a, b) => {
          if (a.startAt > b.startAt) return 1;
          if (a.startAt < b.startAt) return -1;
          return 0;
        });

        this.fees = purchaseFee[purchaseFee.length - 1];
      } catch (e) {
        console.log("could not load fees: ", e);
      }
    },

    callNextState(paymentMode, bluTusd) {
      this.bluTusd = bluTusd;
      this.paymentMode = paymentMode;
      this.forceStateChange();
    },

    setTooLongFalse() {
      this.tooLong = false;
    },

    forceStateChange() {
      if (this.transactionState < 1) {
        this.transactionState = this.transactionState + 1;
        this.scrollToAnchor();
      } else {
        this.transactionState = 0;
      }
    },

    scrollToAnchor() {
      function scrollTo(element) {
        window.scroll({
          behavior: "smooth",
          left: 0,
          top: element.offsetTop - 20,
        });
      }
      scrollTo(document.getElementById("landing_buy_blu"));
    },

    checkTranscationStatus() {
      let trades = this.purchases;

      // //remover - test p
      // this.transactionState = 1;

      for (let i in trades) {
        if (trades[i].status == "waiting") {
          this.purchaseWaiting = trades[i];
          this.transactionState = 1;
        }
      }
      this.loading = false;
    },

    maintenanceCheck(maintananceStatus) {
      this.$emit("maintenanceCheck", maintananceStatus);
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
  computed: {
    ...mapGetters(["accounts", "currencies"]),
  },
  watch: {
    purchases: function () {
      this.checkTranscationStatus();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/private/landing/base_buy_blu/BaseBuyBlu.vue